module.exports = __webpack_public_path__ + "static/tony-artist-profile-45e310b72ae4c441e67ca878b37f20c4.jpg";